import { TinyEmitter } from "@expert/event-bus";

import type { GaiaWebSocketEventType, GaiaWebSocketResponse } from "./types";

export const GAIA_WS_EMITTER_NAME = "gaia_ws";
export type GaiaWsEvents = Record<`${typeof GAIA_WS_EMITTER_NAME}_${GaiaWebSocketEventType}`, GaiaWebSocketResponse>;
export type GaiaWsEventName = keyof GaiaWsEvents;

// `GaiaWebSocketResponse` carries raw, externally-shaped fields (`body: unknown`, `data: any`) —
// the same risk this PR fixes for the WS event bus. Logging is currently off (`loggingEnabled:
// false`, marked TEMP above), so this is a no-op today, but nest the payload now so a future
// logger-migration doesn't reopen the same remote-expert mapping-conflict class of bug.
export const gaiaWsEventBus = new TinyEmitter<GaiaWsEvents>(GAIA_WS_EMITTER_NAME, {
    loggingEnabled: false,
    nestPayloadInLogs: true,
});
